import { removeAccents } from "@/helper/property";

export const formatCityName = (city: string) =>
  removeAccents(city).toLowerCase();
